import React from 'react'

function payment_response() {
  return (
    <div>payment_response</div>
    
  )
}

export default payment_response